import { InjectionToken } from '@angular/core';

import { DatepickerTranslation } from './datepicker-translation.type';

export const DATEPICKER_TRANSLATION = new InjectionToken<DatepickerTranslation>('shrd-uic.datepickerTranslation');
